
import React from 'react';

const Arrow: React.FC = () => {
  return (
    <svg viewBox="0 0 30 28.39" focusable="false" aria-hidden="true">
      <path d="M9.27 16.48L30 0 0 14.51l9.27 1.97zM14.4 18.26l10.43 8.53L30 0 14.4 18.26zM11.44 26.79l4.3-2.81-6.08-4.89 1.78 7.7z" />
    </svg>
  );
};

export default Arrow

